import React from 'react';
import { Stack } from '@mui/material';
import { FieldGroupSection } from './FieldGroupSection';
import { FieldEditGroup } from '../types';

interface ExtractedFieldsPanelProps {
  groups: FieldEditGroup[];
  onChange: (key: string, value: string) => void;
  onRevert: (key: string) => void;
}

export const ExtractedFieldsPanel = ({ groups, onChange, onRevert }: ExtractedFieldsPanelProps) => (
  <Stack spacing={2}>
    {groups.map(group => (
      <FieldGroupSection
        key={group.groupLabel}
        groupLabel={group.groupLabel}
        fields={group.fields}
        onChange={onChange}
        onRevert={onRevert}
      />
    ))}
  </Stack>
);
